import ApiClient from '../../../../shared/ApiCliente';
import { Company } from '../../../../types';

// Interface para o objeto de inscrição retornado pela API /registro-empresa
export interface UserSub {
  company: string;
  userId: string;
  emailNotification: string;
  phoneNUmberNotification: string;
  telegramChatId: string | null;
}

export const userCompanyService = {
  getUserCompanies: async (): Promise<UserSub[]> => {
    try {
      const response = await ApiClient.get<UserSub[]>('/registro-empresa');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar empresas do usuário:', error);
      return [];
    }
  },

  addToWatchlist: async (companyId: string): Promise<boolean> => {
    try {
      // O endpoint espera um corpo de solicitação com companyId
      await ApiClient.post('/registro-empresa', { companyId });
      return true;
    } catch (error) {
      console.error('Erro ao adicionar empresa à lista de observação:', error);
      return false;
    }
  },

  removeFromWatchlist: async (companyId: string): Promise<boolean> => {
    try {
      // O endpoint espera o companyId como parte da URL
      await ApiClient.delete(`/registro-empresa/${companyId}`);
      return true;
    } catch (error) {
      console.error('Erro ao remover empresa da lista de observação:', error);
      return false;
    }
  },
};
